/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureFlag } from './FeatureFlag';
import {
    FeatureFlagFromJSON,
    FeatureFlagFromJSONTyped,
    FeatureFlagToJSON,
} from './FeatureFlag';

/**
 * 
 * @export
 * @interface SetCustomerModuleBody
 */
export interface SetCustomerModuleBody {
    /**
     * 
     * @type {Array<FeatureFlag>}
     * @memberof SetCustomerModuleBody
     */
    features: Array<FeatureFlag>;
    /**
     * 
     * @type {boolean}
     * @memberof SetCustomerModuleBody
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the SetCustomerModuleBody interface.
 */
export function instanceOfSetCustomerModuleBody(value: object): value is SetCustomerModuleBody {
    if (!('features' in value) || value['features'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function SetCustomerModuleBodyFromJSON(json: any): SetCustomerModuleBody {
    return SetCustomerModuleBodyFromJSONTyped(json, false);
}

export function SetCustomerModuleBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCustomerModuleBody {
    if (json == null) {
        return json;
    }
    return {
        
        'features': ((json['features'] as Array<any>).map(FeatureFlagFromJSON)),
        'enabled': json['enabled'],
    };
}

export function SetCustomerModuleBodyToJSON(value?: SetCustomerModuleBody | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'features': ((value['features'] as Array<any>).map(FeatureFlagToJSON)),
        'enabled': value['enabled'],
    };
}

